export const environment = {
    production: false,
    firebase: {
        /*apiKey: "AIzaSyDxQ9kjzNpZAYd18Se2DkLt526EjlnydJU",
        authDomain: "fir-crud-1eb79.firebaseapp.com",
        databaseURL: "https://fir-crud-1eb79.firebaseio.com",
        projectId: "fir-crud-1eb79",
        storageBucket: "fir-crud-1eb79.appspot.com",
        messagingSenderId: "636105722911"*/
        apiKey: "AIzaSyCpMmAvKoVEXGu-btIGrYsf_pNa-Ze9zg4",
        authDomain: "barbooking-7e77a.firebaseapp.com",
        databaseURL: "https://barbooking-7e77a.firebaseio.com",
        projectId: "barbooking-7e77a",
        storageBucket: "barbooking-7e77a.appspot.com",
        messagingSenderId: "868283186509"
    }
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts